import ErrorComponent from './ErrorPage';

export * from './ErrorPage';
export default ErrorComponent;
